import React from "react";
import { Link, useLocation } from "react-router-dom";

function FormsyLink({
  contactID,
  clientProgram,
  formName,
  formVersionId,
  formPath,
  formVersionNumber,
  tab,
}) {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("safyInfo")).user;
  return (
    <div className="mb-2 d-flex">
      <div className="bg-safy-info rounded fw-bold ms-4 px-2 me-1 text-white">
        {" "}
        F
      </div>
      <Link
        title={`Add ${formName}`}
        className=" text-primary"
        style={{ textDecoration: "none" }}
        to={`../${formPath}${
          formPath !== "form" &&
          formVersionNumber !== undefined &&
          formVersionNumber !== "1"
            ? `v${formVersionNumber}`
            : ""
        }/${formVersionId}/${contactID.toString().replace(/[{}]/g, "")}`}
        state={{
          client: clientProgram.ccx_patient,
          clientProgram: {
            "#text": clientProgram.ccx_client_programid,
            "@name": clientProgram.ccx_name,
          },
          SubmissionId: "",
          initialData: {},
          comments: "",
          createdBy: {
            "#text": user.safyInfo.SystemUserId,
            "@name": user.displayName,
          },
          previousData: {},
          tab: tab,
          previousPath: location.pathname,
          selectedProgram: clientProgram,
        }}
      >
        {formName}
      </Link>
    </div>
  );
}

export default FormsyLink;
